/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ elapsed: NonNullable<unknown> }} Chat_Turn_ElapsedInputs */



/**
* | output |
* | --- |
* | "Running for {elapsed}" |
*
* @param {Chat_Turn_ElapsedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_turn_elapsed = /** @type {((inputs: Chat_Turn_ElapsedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Turn_ElapsedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Läuft seit ${i?.elapsed}`)
	return /** @type {LocalizedString} */ (`Running for ${i?.elapsed}`)
});